import * as installer from './installer';

export const install = installer.install;
export const version = installer.version;

export default installer;
